/**
 * Marca como decorativas (`alt=""`) as imagens sem `alt` do HTML de um passo do tutorial.
 *
 * O `tutorial__c` traz as ilustrações sem `alt`, e o leitor de tela anunciaria o nome do
 * arquivo ("6463ccfe…_original_Asset 1.svg"). Elas só ilustram o título do passo, que já diz
 * tudo. Uma imagem que já tem `alt` fica como está.
 */
export function withDecorativeImages(html: string) {
  const container = document.createElement('div');
  container.innerHTML = html;

  container.querySelectorAll('img:not([alt])').forEach(image => image.setAttribute('alt', ''));

  return container.innerHTML;
}
